/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillid1Inputs */

const en_entity_skillid1 = /** @type {(inputs: Entity_Skillid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill ID`)
};

const de_entity_skillid1 = /** @type {(inputs: Entity_Skillid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Skill ID" |
*
* @param {Entity_Skillid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillid1 = /** @type {((inputs?: Entity_Skillid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillid1(inputs)
	return de_entity_skillid1(inputs)
});
export { entity_skillid1 as "entity_skillId" }